module.exports = __webpack_public_path__ + "img/waterfall-cn-2.c78a3ea.svg";